const verifyEmail = (value) => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};
// function that verifies if a string has a given length or not
const verifyLength = (value, length) => {
  if (value.length >= length) {
    return true;
  }
  return false;
};
const verifyMaxLength = (value, length) => {
  if (value.length === length) {
    return true;
  }
  return false;
};
// function that verifies if value contains only numbers
const verifyNumber = (value) => {
  var numberRex = new RegExp("^[0-9]+$");
  if (numberRex.test(value)) {
    return true;
  }
  return false;
};
// verifies if value is a valid URL
const verifyUrl = (value) => {
  try {
    new URL(value);
    return true;
  } catch (_) {
    return false;
  }
};
// verifies if value is equal to other value
const verifyEqual = (value, confirmValue) => {
  if (value === confirmValue) {
    return true;
  }
  return false;
};

// RFC validation
const rfcRegex = /^([A-ZÑ&]{3,4})\d{6}([A-Z0-9]{3})$/;
const verifyRFC = (rfc) => rfcRegex.test(rfc.toUpperCase().trim());

export {
  verifyEmail,
  verifyLength,
  verifyMaxLength,
  verifyNumber,
  verifyUrl,
  verifyEqual,
  verifyRFC,
};
